<template>
    <div class="p-4 lg:w-1/1 md:w-full">
        <div class="flex items-center gap-2">
            <JetLabel class="w-1/4 my-2" for="id_paket_pengadaan" value="Paket Pengadaan" />
            <Dropdown v-model="form.paket_pengadaan" :loading="loading" :options="pengadaanOption"
                optionLabel="nama_paket_pengadaan" filter filterBy="nama_paket_pengadaan" @filter="fetchPaketPengadaan
                    " placeholder="Select Paket Pengadaan" class="w-3/4" @change="onPaketPengadaanChange" />
        </div>
        
        <!-- Detail Paket Pengadaan -->
        <div v-if="paketDetail" class="mt-4 p-4 bg-gray-50 rounded-lg">
            <h4 class="font-semibold text-lg mb-3 text-gray-800">Detail Paket Pengadaan</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="space-y-2">
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">Nama Paket:</span>
                        <span class="text-gray-900">{{ paketDetail.nama_paket_pengadaan }}</span>
                    </div>
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">Pagu Anggaran:</span>
                        <span class="text-gray-900">Rp {{ formatNumber(paketDetail.pagu_anggaran) }}</span>
                    </div>
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">Jenis Pengadaan:</span>
                        <span class="text-gray-900">{{ paketDetail.jenis_pengadaan }}</span>
                    </div>
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">Metode Pemilihan:</span>
                        <span class="text-gray-900">{{ paketDetail.metode_pemilihan }}</span>
                    </div>
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">Unit Kerja:</span>
                        <span class="text-gray-900">{{ paketDetail.unit_kerja }}</span>
                    </div>
                </div>
                <div class="space-y-2">
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">PPK:</span>
                        <span class="text-gray-900">{{ paketDetail.ppk }}</span>
                    </div>
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">MAK:</span>
                        <span class="text-gray-900">{{ paketDetail.mak }}</span>
                    </div>
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">Mulai Pemilihan:</span>
                        <span class="text-gray-900">{{ paketDetail.jadwal_mulai_pemilihan_penyedia }}</span>
                    </div>
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">Selesai Pemilihan:</span>
                        <span class="text-gray-900">{{ paketDetail.jadwal_selesai_pemilihan_penyedia }}</span>
                    </div>
                    <div class="flex">
                        <span class="font-medium text-gray-700 w-1/3">Mulai Kontrak:</span>
                        <span class="text-gray-900">{{ paketDetail.jadwal_mulai_pelaksanaan_kontrak }}</span>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <div class="flex">
                    <span class="font-medium text-gray-700 w-1/6">Ruang Lingkup:</span>
                    <span class="text-gray-900">{{ paketDetail.ruang_lingkup_pengadaan }}</span>
                </div>
            </div>
            <div class="mt-4">
                <div class="flex">
                    <span class="font-medium text-gray-700 w-1/6">Spesifikasi:</span>
                    <span class="text-gray-900">{{ paketDetail.spesifikasi_pekerjaan }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import JetLabel from "@/Jetstream/Label";

export default defineComponent({
    components: {
        InputNumber,
        Dropdown,
        RadioButton,
        JetLabel,
    },
    props: {
        form: Object,
    },
    mounted() {
        this.fetchPaketPengadaan({ query: "" });
    },
    data() {
        return {
            pengadaanOption: [],
            loading: false,
            paketDetail: null,
        };
    },
    methods: {

        async fetchPaketPengadaan(event) {
            this.loading = true;
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/dokumen_pengadaan/search_paket_pengadaan",
                    {
                        params: {
                            keyword: event?.value || "",
                        },
                    }
                );
                this.pengadaanOption = response.data;
            } catch (error) {
                console.error("Error fetching paket pengadaan:", error);
            }
            this.loading = false;
        },

        async onPaketPengadaanChange() {
            if (this.form.paket_pengadaan && this.form.paket_pengadaan.id) {
                await this.fetchPaketDetail(this.form.paket_pengadaan.id);
                this.changeMetodeEvaluasi();
            } else {
                this.paketDetail = null;
            }
            this.$emit("update:form", this.form.paket_pengadaan);
            this.$emit("paket-detail-updated", this.paketDetail);
        },

        changeMetodeEvaluasi() {
            if (this.form.paket_pengadaan && this.form.paket_pengadaan.penyedia_jenis_pekerjaan_id != 3) {
                this.form.metode_evaluasi = "1f";
            } else {
                this.form.metode_evaluasi = "2f";
            }
        },

        async fetchPaketDetail(id) {
            try {
                const response = await axios.post("/dokumen_pengadaan/get_detail_paket_pengadaan", {
                    id: id
                });
                
                if (response.data.success) {
                    this.paketDetail = response.data.data;
                } else {
                    console.error("Error fetching paket detail:", response.data.message);
                    this.paketDetail = null;
                }
            } catch (error) {
                console.error("Error fetching paket detail:", error);
                this.paketDetail = null;
            }
        },

        formatNumber(value) {
            if (!value) return '0';
            return new Intl.NumberFormat('id-ID').format(value);
        },
    },
    watch: {
        'form.paket_pengadaan': {
            handler(newValue) {
                this.$emit("update:form", newValue);
            },
            deep: true
        }
    }
});
</script>